import React from 'react'
import AppBar from '@material-ui/core/AppBar'
import { makeStyles } from '@material-ui/core'
import ExitToAppOutlinedIcon from '@material-ui/icons/ExitToAppOutlined'
import MenuItem from '@material-ui/core/MenuItem'
import Menu from '@material-ui/core/Menu'
import Button from '@material-ui/core/Button'
import { Link } from 'react-router-dom'
import Toolbar from '@material-ui/core/Toolbar'
import { logout } from '../../../../../actions/AuthAction'
import { useDispatch } from "react-redux";

const useStyles = makeStyles((theme) => {
  return {
    appbar: {
      zIndex: theme.zIndex.drawer + 1,
    },
    logo: {
      flexGrow: 1,
    },
  }
})

const Navbar = () => {
  const dispatch = useDispatch();
  const classes = useStyles()
  const [anchorEl, setAnchorEl] = React.useState(null)
  const open = Boolean(anchorEl)

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget)
  }
  const handleClose = () => {
    setAnchorEl(null)
    console.log('logout')
  }
  return (
    <AppBar elevation={0} position='fixed' className={classes.appbar}>
      <Toolbar>
        <Link to='/Dashboard' className={classes.logo}>
          <img src='/Img/MainLogo.svg' alt='#' />
        </Link>
        <Button color='inherit' onClick={handleMenu}>
          <ExitToAppOutlinedIcon />
        </Button>
        <Menu
          id='menu-appbar'
          anchorEl={anchorEl}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          keepMounted
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          open={open}
          onClose={handleClose}
        >
          <MenuItem onClick={() => dispatch(logout())}>Logout</MenuItem>
        </Menu>
      </Toolbar>
    </AppBar>
  )
}


export default Navbar
